import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { BRAND } from "@/data/site";
import { ShieldCheck } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      navigate(user.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5 py-20" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="mb-8 flex items-center justify-center gap-3">
          <div className="overflow-hidden rounded-md bg-[#EEF2FB] p-1"><img src={BRAND.logo} alt="logo" className="h-10 w-10 object-contain" /></div>
          <span className="font-heading text-lg font-bold text-white">Unicorn Valley</span>
        </Link>
        <div className="rounded-2xl bg-white p-8">
          <h1 className="font-heading text-2xl font-semibold text-ink">Welcome back</h1>
          <p className="mt-1 text-sm text-slate-500">Sign in to track your sourcing & shipments.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="w-full rounded-md border border-slate-200 px-4 py-3 text-sm outline-none focus:border-teal focus:ring-2 focus:ring-teal/30" />
            <input required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="w-full rounded-md border border-slate-200 px-4 py-3 text-sm outline-none focus:border-teal focus:ring-2 focus:ring-teal/30" />
            {error && <p className="text-sm text-red-600" data-testid="login-error">{error}</p>}
            <button type="submit" disabled={loading} data-testid="login-submit" className="w-full rounded-md bg-gradient-to-r from-[#1E73BE] to-[#16B894] px-6 py-3.5 text-sm font-semibold text-white hover:-translate-y-0.5 transition-transform disabled:opacity-60">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
          <p className="mt-5 text-center text-sm text-slate-500">
            New client? <Link to="/register" className="font-semibold text-teal hover:underline">Create an account</Link>
          </p>
          <div className="mt-6 flex items-start gap-2 rounded-lg bg-mist p-4 text-xs text-slate-500">
            <ShieldCheck size={18} className="mt-0.5 shrink-0 text-teal" />
            <div>
              <p className="font-semibold text-ink">Demo client login</p>
              <p>client@demo.com · Client@2026</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
